import { combineReducers } from 'redux';
import { userLoginReducer } from "./userReducers";
import { addPropertyReducer, getApprovedPropertyReducer, getPropertyIDReducer } from "./propertyReducers";

const reducer = combineReducers({
  userLogin: userLoginReducer,
  addProperty: addPropertyReducer,
  getApprovedProperty: getApprovedPropertyReducer,
  getPropertyID: getPropertyIDReducer
})

export default reducer;